import React from 'react';
import { Chip } from '@mui/material';
import {
  getApiPresenceStatusMeta,
  getConsentStatusMeta,
  getEnrollmentStatusMeta,
  getHasLiveSelectionsMeta,
  getProductSelectionStatusMeta,
  getSelectionLifecycleStatusMeta,
  getTerminationStatusMeta,
} from '../../utils/status';

const buildStatusChip = (meta) => {
  if (!meta) return '';
  const color = meta.color && meta.color !== 'default' ? meta.color : 'default';
  const variant = color === 'default' ? 'outlined' : 'filled';
  return <Chip size="small" label={meta.label || 'Unknown'} color={color} variant={variant} />;
};

const normalizeBooleanLike = (value) => {
  if (typeof value === 'boolean') return value;
  if (typeof value === 'number') return value !== 0;
  if (typeof value === 'string') {
    const normalized = value.trim().toLowerCase();
    if (!normalized) return null;
    if (['true', '1', 'yes', 'y'].includes(normalized)) return true;
    if (['false', '0', 'no', 'n'].includes(normalized)) return false;
  }
  return null;
};

const getHistoryStatusMeta = (field, value) => {
  if (!field) return null;
  const normalizedField = String(field).toLowerCase();
  const rawValue = value ?? '';
  if (normalizedField.includes('apipresence')) {
    return getApiPresenceStatusMeta(rawValue);
  }
  if (normalizedField.includes('enrollmentstatus')) {
    return getEnrollmentStatusMeta(rawValue);
  }
  if (normalizedField.includes('programselectionstatus')) {
    return getProductSelectionStatusMeta(rawValue);
  }
  if (normalizedField.includes('productselectionstatus')) {
    if (normalizedField.includes('productselections') || normalizedField === 'productselectionstatus') {
      return getSelectionLifecycleStatusMeta(rawValue);
    }
    return getProductSelectionStatusMeta(rawValue);
  }
  if (normalizedField.includes('dataconsentstatus') || normalizedField.includes('programconsentstatus')) {
    return getConsentStatusMeta(rawValue);
  }
  if (normalizedField.includes('hasliveselections')) {
    return getHasLiveSelectionsMeta(normalizeBooleanLike(rawValue));
  }
  if (normalizedField.includes('isterminated')) {
    return getTerminationStatusMeta(normalizeBooleanLike(rawValue));
  }
  return null;
};

const renderHistoryValue = (field, value) => {
  const meta = getHistoryStatusMeta(field, value);
  if (meta) {
    return buildStatusChip(meta);
  }
  return value ?? '';
};

export {
  buildStatusChip,
  getHistoryStatusMeta,
  normalizeBooleanLike,
  renderHistoryValue,
};
